import React from 'react';
import styled from 'styled-components';
import Modal from "components/Artists/Modal";
import { Button } from "ui-kit/Button";
import {FormattedMessage} from "react-intl";

interface DeletePreviewImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeletePreviewImageModal: React.FC<DeletePreviewImageModalProps> = props => {
  const { isOpen, onClose, onDelete } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalBody>
        <Message>
          <FormattedMessage
            id="Labels.DeletePreviewImageModal.Question"
            defaultMessage="Are you sure you want to delete cover art?"
          />
        </Message>
        <Actions>
          <CancelButton onClick={onClose}>
            <FormattedMessage
              id="Labels.DeletePreviewImageModal.No"
              defaultMessage="No"
            />
          </CancelButton>
          <Button onClick={onDelete}>
            <FormattedMessage
              id="Labels.DeletePreviewImageModal.Yes"
              defaultMessage="Yes"
            />
          </Button>
        </Actions>
      </ModalBody>
    </Modal>
  );
};

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 35px 0;
`;

const Message = styled.div`
  width: 374px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #000000;
`;

const CancelButton = styled.div`
  width: 60px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  cursor: pointer;
`;
